import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputSwitch} from "primereact/inputswitch";
import {ColorPicker} from "primereact/colorpicker";
import axios from "axios";
import ProjectstatusRuleEditorComponent from "./ProjectstatusRuleEditorComponent";

const ProjectstatusFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().projectstatusId) || (entity === 'project-status' && id)) {
      apiCall('patch', '/api/v2/project-status/' + (window.App.urlVars().projectstatusId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectstatusList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/project-status', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectstatusList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/project-status/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().projectstatusId) || (entity === 'project-status' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/project-status/' + (window.App.urlVars().projectstatusId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"projectstatus-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      name: e.target.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      name: e.target.value
                                    })
                                  }}
                                  value={formData.name}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="color" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="color"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldColor')}</label>
                  <span className="p-inputgroup">
                      <InputText id="color" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      color: '#' + e.target.value.replace('#', '')
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      color: '#' + e.target.value.replace('#', '')
                                    })
                                  }}
                                  value={formData.color}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                  style={{width: '80%'}}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label htmlFor="color">&nbsp;</label>
                <span className="">
                      <ColorPicker value={formData.color}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        color: '#' + e.target.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        color: '#' + e.target.value.replace('#', '')
                                      })
                                    }}

                      />
                    </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldActive')}</label>
                  <span className="p-d-block">
                        <InputSwitch
                          className={"p-mt-1"}
                          checked={formData.active}
                          value={formData.active}
                          onChange={(e) => {
                            setFormData({...formData, active: e.target.value})
                            setNewFormData({...newFormData, active: e.target.value})
                          }}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="archive_project" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="archive_project"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldArchiveProject')}</label>
                  <span className="p-d-block">
                        <InputSwitch
                          className={"p-mt-1"}
                          checked={formData.archive_project}
                          value={formData.archive_project}
                          onChange={(e) => {
                            setFormData({...formData, archive_project: e.target.value})
                            setNewFormData({...newFormData, archive_project: e.target.value})
                          }}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'project-status' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
      {formData.id &&
        <ProjectstatusRuleEditorComponent projectStatusId={formData.id} t={t}/>
      }
    </div>
  )
}
export default withTranslation('common')(ProjectstatusFormComponent);
